import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import ProfileContext from "./ProfileContext";
import useUsers from "../../hooks/useUsers";
import { PAGE_STATE } from "../../constants";
import AppContext from "../../AppContext";
import List, { STATE } from "../../components/List";
import SecondaryPagination from "../../components/SecondaryPagination/SecondaryPagination";
import ChatSessionContext from "../../contexts/ChatSessionContext";
import { ReactComponent as MessageSvg } from "../../assets/profile/message.svg";
const assetsUri = import.meta.env.ASSETS_URI;

const columns = [
  {
    display: "Name",
    key: "user",
    textAlign: "left",
  },
  {
    display: "",
    key: "actions",
    textAlign: "left",
    maxWidth: 200,
  },
];

const Followers = (props) => {
  const { user: loggedInUser, plans, viewProfile } = useContext(AppContext);
  const { startChat } = useContext(ChatSessionContext);
  const { isCompany, user, company, isOwner } = useContext(ProfileContext);
  const { queryUsers, querySubscriptions, patchSubscription, queryCompanies } =
    useUsers();
  const [followers, setFollowers] = useState(undefined);
  const [dataState, setDataState] = useState(STATE.LOADING);

  useEffect(() => {
    fetchData();
  }, [user, company, isCompany]);

  const fetchData = async () => {
    const _filter = {
      subscribes: isCompany ? company._id : user._id,
      deleted: false,
      active: true,
    };

    const { data } = await querySubscriptions(_filter, null, -1, {
      createdBy: 1,
      company: 1,
    });

    const _userIds = data.filter((d) => !d.company).map((d) => d.createdBy);
    const _companyIds = data.filter((d) => !!d.company).map((d) => d.company);

    let _users = [];
    let _companies = [];

    if (_userIds.length > 0) {
      const { data: users } = await queryUsers(
        {
          _id: {
            $in: _userIds,
          },
        },
        null,
        -1,
        { avatar: 1, firstname: 1, surname: 1, plan: 1, uri: 1 }
      );

      _users = users;
    }

    if (_companyIds.length > 0) {
      const { data: companies } = await queryCompanies(
        {
          _id: {
            $in: _companyIds,
          },
        },
        null,
        -1,
        { logo: 1, name: 1, enterprise: 1 }
      );

      _companies = companies;
    }

    // * Map users
    let _followers = data.map((s) => {
      let _ = {
        _id: s._id,
        avatar: null,
        name: "-",
        plan: "-",
        userId: s.createdBy,
      };

      if (s.company) {
        const _companyMatch = _companies.find((c) => c._id === s.company);

        if (!_companyMatch) return null;

        _ = {
          _id: _companyMatch._id,
          avatar: _companyMatch.logo,
          name: _companyMatch.name,
          isCompany: true,
          plan: _companyMatch.enterprise ? "Enterprise" : "Business",
        };
      }

      if (!s.company) {
        const _userMatch = _users.find((u) => u._id === s.createdBy);

        if (!_userMatch) return null;

        // * Get plan
        const planFound = plans.find((p) => p._id === _userMatch.plan);

        _ = {
          _id: _userMatch._id,
          avatar: _userMatch.avatar,
          name: `${_userMatch.firstname} ${_userMatch.surname ?? ""}`,
          uri: _userMatch.uri,
          isCompany: false,
          plan: planFound.name,
        };
      }

      const { avatar, name, plan, _id, isCompany, uri } = _;

      return {
        userId: _id,
        isCompany,
        uri,
        user: (
          <div className="profile-followers-list-user">
            <img
              className="profile-followers-list-user__avatar"
              alt="follower-avatar"
              src={`${assetsUri}/${avatar}`}
              onError={({ target }) => {
                target.src = avatar;
              }}
            />
            <div className="profile-followers-list-user__name">{name}</div>
            <div className="profile-followers-list-user__plan">{plan}</div>
          </div>
        ),
        actions: (
          <div className="profile-followers-list-user-actions">
            {_id !== loggedInUser?._id && (
              <span
                className="profile-followers-list-user-actions__item"
                onClick={(e) => {
                  e.stopPropagation();
                  startChat(_id, loggedInUser);
                }}
              >
                <MessageSvg height={22} />
                Chat
              </span>
            )}
          </div>
        ),
      };
    });

    setFollowers(_followers.filter((f) => !!f));
    setDataState(STATE.IDLE);
  };

  const handleUserClick = (e) => {
    viewProfile(e.userId);
  };

  return (
    <div className="profile-followers">
      <List
        className="profile-followers-list"
        contentState={dataState}
        columns={columns}
        dataSource={followers}
        viewable={true}
        onRecordClick={handleUserClick}
      />
    </div>
  );
};

Followers.propTypes = {};

export default Followers;
